import { render, staticRenderFns } from "./AdminStudentList.vue?vue&type=template&id=b388cd3a&scoped=true&"
import script from "./AdminStudentList.vue?vue&type=script&lang=js&"
export * from "./AdminStudentList.vue?vue&type=script&lang=js&"
import style0 from "./AdminStudentList.vue?vue&type=style&index=0&id=b388cd3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b388cd3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VDataTable,VDialog,VIcon,VTextField})
